import { initAll, track } from '@amplitude/unified';
import { Platform } from 'react-native';

let started = false;

// Analytics must never interrupt navigation or search.
export function trackAmplitude(name: string, properties?: Record<string, string>): void {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return;
    const key = process.env.EXPO_PUBLIC_AMPLITUDE_API_KEY;
    if (!key) return;

    try {
        if (!started) {
            void initAll(key, {
                serverZone: 'US',
                analytics: { autocapture: false, remoteConfig: { fetchRemoteConfig: false } },
                sessionReplay: { sampleRate: 0 }
            }).catch(error => console.warn('[amplitude] Initialization failed', error));
            started = true;
        }
        track(name, properties);
    } catch (error) {
        console.warn('[amplitude] Unable to track event', error);
    }
}
